<template lang="pug">
v-container
  h1 PAYOUT HISTORY
  v-tabs.mt-2(grow background-color="#fafafa" v-model="tab")
      v-tab Pending
      v-tab Done
</template>

<script>
export default {
  name: 'PayoutHistory',
  data: () => ({
  })
}
</script>

<style lang="scss" scoped>

</style>